<div
  class="message-actions-container"
  [class.show-actions]="showActions()"
>
  <div class="message-actions">
    <button
      *ngFor="let button of buttons"
      mat-icon-button
      class="message-action-button"
      [ngClass]="getButtonClass(button)"
      [disabled]="isButtonDisabled(button)"
      [matTooltip]="button.tooltip"
      matTooltipPosition="left"
      (click)="button.action()"
    >
      <mat-icon>{{ getButtonIcon(button) }}</mat-icon>
    </button>
  </div>
</div>
